const pressSave = (payload) => {
  return {
    type: "savedata",
    payload,
  };
};

export default pressSave;
